
  import { computed, defineComponent } from 'vue';
  import { Button, Icon, Notification, Spinner, Typography } from '@voximplant/spaceui';
  import { useI18n } from 'vue-i18n';
  import { useStore } from 'effector-vue/composition';
  import { $settings } from '@/store/settings';
  import { vFocusTrap } from '@/helper/trapFocusElements';
  import { $notificationState, $showNotification, NotificationContent } from '@/store/notification';
  import { $calls, $currentActiveCallId, $currentSelectCallId } from '@/store/calls';

  export default defineComponent({
    name: 'NotificationBlock',

    components: {
      Typography,
      Notification,
      Button,
      Spinner,
      Icon,
    },
    directives: {
      'focus-trap': vFocusTrap,
    },
    setup() {
      const { t } = useI18n();
      const showNotification = useStore($showNotification);
      const notificationState = useStore($notificationState);
      const settings = useStore($settings);
      const calls = useStore($calls);
      const currentActiveCallId = useStore($currentActiveCallId);
      const currentSelectCallId = useStore($currentSelectCallId);

      const notificationClasses = computed(() => ({
        minimize: showNotification && settings.value.minimize,
      }));
      const iconSize = computed(() => (settings.value.minimize ? 24 : 40));
      const minimizeAppendix = computed(() =>
        NotificationContent[notificationState.value].showMinimazeText && settings.value.minimize
          ? 'Minimize'
          : ''
      );

      const notificationContent = computed(() => ({
        iconName: NotificationContent[notificationState.value].icon,
        iconSize,
        iconColor: NotificationContent[notificationState.value].iconColor,
        title: t(`${notificationState.value}.title${minimizeAppendix.value}`),
        text: t(`${notificationState.value}.text${minimizeAppendix.value}`),
        buttonIcon: NotificationContent[notificationState.value].buttonIcon,
        showSpinner: NotificationContent[notificationState.value].showSpinner,
        buttonMode: NotificationContent[notificationState.value].buttonMode,
        showButton:
          notificationState.value === 'reconnecting'
            ? currentActiveCallId.value ||
              calls.value[currentSelectCallId.value]?.call?.state() === 'PROGRESSING'
            : NotificationContent[notificationState.value].showButton,
        buttonAction: NotificationContent[notificationState.value].buttonAction,
      }));
      const buttonText = computed(() => {
        return NotificationContent[notificationState.value].buttonIcon && settings.value.minimize
          ? ''
          : t(`${notificationState.value}.button`);
      });

      return {
        t,
        showNotification,
        notificationState,
        settings,
        iconSize,
        notificationClasses,
        notificationContent,
        NotificationContent,
        currentActiveCallId,
        buttonText,
      };
    },
  });
